const deviceTypes = require('node-device-detector/parser/const/device-type-id');
const deviceBrands = require('node-device-detector/parser/device/brand-short');
const browsers = require('node-device-detector/parser/client/browser-short');
const operatingSystems = require('node-device-detector/parser/os/os_systems');

const relationToColumn = {
  referrerType: 'referer_type',
  referrerName: 'referer_name',
  referrerKeyword: 'referer_keyword',
  referrerUrl: 'referer_url',
  browser: 'concat(config_browser_name, \' \', config_browser_version)',
  browserName: 'config_browser_name',
  browserVersion: 'config_browser_version',
  operatingSystem: 'concat(config_os, \' \', config_os_version)',
  operatingSystemName: 'config_os',
  operatingSystemVersion: 'config_os_version',
  url: 'idaction_url_name',
  pageTitle: 'idaction_name_name',
  eventCategory: 'idaction_event_category_name',
  eventAction: 'idaction_event_action_name',
  eventName: 'idaction_name_name',
  deviceType: 'config_device_type',
};

const referrerTypes = {
  direct: 1,
  search: 2,
  website: 3,
  campaign: 6,
  social: 7,
};

module.exports = {
  relationToColumn,
  referrerTypes,
  deviceTypes,
  deviceBrands,
  browsers,
  operatingSystems,
};
